import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { defineAsyncComponent, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    display: { type: Boolean },
    name: null,
    note: null,
    placeholder: null,
    required: { type: Boolean },
    type: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { display: boolean, name: string, note: string, placeholder: string, required: boolean, type: string, modelValue: string | null }





const component = defineAsyncComponent(() => import(`./${props.type}.vue`))

function onUpdateModelValue(e: any) {
  emit('update:modelValue', e)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(component))
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), _mergeProps({ key: 0 }, { required: __props.required, placeholder: __props.placeholder, modelValue: __props.modelValue }, { "onUpdate:modelValue": onUpdateModelValue }), null, 16))
      : _createCommentVNode("", true)
  ]))
}
}

})